import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { Container, ContentWithPaddingXl } from "../misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "../misc/Headings";
import { SectionDescription } from "../misc/Typography";
import { ReactComponent as LinkedinIcon } from "../../images/linkedin-icon.svg";

const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)``;
const Subheading = tw(SubheadingBase)`text-center mb-3`;
const Description = tw(SectionDescription)`mx-auto text-center`;

const Cards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-5xl mx-auto`;
const Card = tw.div`mt-24 w-full sm:w-1/2 lg:w-1/3 flex flex-col items-center`;
const CardImage = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`w-64 h-64 bg-contain bg-center rounded`}
`;
const CardContent = styled.div`
  ${tw`flex flex-col items-center mt-6`}
  .position {
    ${tw`uppercase text-base font-bold tracking-widest text-primary-400`}
  }
  .about{
    ${tw`text-center w-64`}
  }
  .name {
    ${tw`mt-1 text-xl font-medium text-gray-900`}
`;

const CardLinks = styled.div`
  ${tw`mt-6 flex`}
  .link {
    ${tw`mr-8 last:mr-0 text-gray-400 hocus:text-changed-100 transition duration-300`}
    .icon {
      ${tw`fill-current w-6 h-6`}
    }
  }
`;

const TeamCardGrid = () => {
  const heading = "Meet These Fine Folks.",
    subheading = "Our Team",
    description =
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    cards = [
      {
        imageSrc:
          "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
        position: "CEO",
        name: "Utsav Bhardwaj",
        about:
          "He is an alumnus of IIT Madras, and  presently a Doctoral Student at The University of Queensland, Australia. Earlier, he has worked at Eaton India Innovation Center, Pune; and IIT Madras Incubation Cell, Chennai.",
        links: [
          {
            url: "https://linkedin.com",
            icon: LinkedinIcon,
          },
        ],
      },
      {
        imageSrc:
          "https://images.unsplash.com/photo-1546820389-44d77e1f3b31?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
        position: "CTO",
        name: "Rakesh Patil",
        about:
          "He is a research scholar at IIT Madras, and has worked earlier as a Software Engineer at Intel, Bangalore; and a Graphics Engineer at Nvidia, Bangalore.",
        links: [
          {
            url: "https://linkedin.com",
            icon: LinkedinIcon,
          },
        ],
      },
    ];
  const cardsRow2 = [
    {
      imageSrc:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
      position: "Full Stack Developer",
      name: "Suryansh",
      about: "Undergraduate Student, IIT Kanpur",
      links: [
        {
          url: "https://linkedin.com",
          icon: LinkedinIcon,
        },
      ],
    },

    {
      imageSrc:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
      position: "Full Stack Developer",
      name: "Satyaprakash Dewangan",
      about: "Undergraduate Student, BIT Durg",
      links: [
        {
          url: "https://linkedin.com",
          icon: LinkedinIcon,
        },
      ],
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
      position: "Full Stack Developer",
      name: "Satyapragnya Kar",
      about: "Undergraduate Student, IIT Delhi",
      links: [
        {
          url: "https://linkedin.com",
          icon: LinkedinIcon,
        },
      ],
    },
  ];
  const cardsRow3 = [
    {
      imageSrc:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
      position: "Mentor",
      name: "Vaibhav Goyal",
      about:
        "He is an alumnus of IIT Madras and SP Jain Institute of Management & Research. He holds a sound professional experience of around 19 years, distributed across various technological roles at firms like Nokia, DigiVive, Hungama, Jio, Shemaroo Entertainment Ltd., etc. ",
      links: [
        {
          url: "https://linkedin.com",
          icon: LinkedinIcon,
        },
      ],
    },
  ];
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading>}
          {description && <Description>{description}</Description>}
        </HeadingContainer>
        <Cards>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardImage imageSrc={card.imageSrc} />
              <CardContent>
                <span className="position">{card.position}</span>
                <span className="name">{card.name}</span>
                <span className="about">{card.about}</span>
                <CardLinks>
                  {card.links.map((link, linkIndex) => (
                    <a key={linkIndex} className="link" href={link.url}>
                      <link.icon className="icon" />
                    </a>
                  ))}
                </CardLinks>
              </CardContent>
            </Card>
          ))}
        </Cards>
        <Cards>
          {cardsRow2.map((card, index) => (
            <Card key={index}>
              <CardImage imageSrc={card.imageSrc} />
              <CardContent>
                <span className="position">{card.position}</span>
                <span className="name">{card.name}</span>
                <span className="about">{card.about}</span>
                <CardLinks>
                  {card.links.map((link, linkIndex) => (
                    <a key={linkIndex} className="link" href={link.url}>
                      <link.icon className="icon" />
                    </a>
                  ))}
                </CardLinks>
              </CardContent>
            </Card>
          ))}
        </Cards>
        <Cards>
          {cardsRow3.map((card, index) => (
            <Card key={index}>
              <CardImage imageSrc={card.imageSrc} />
              <CardContent>
                <span className="position">{card.position}</span>
                <span className="name">{card.name}</span>
                <span className="about">{card.about}</span>
                <CardLinks>
                  {card.links.map((link, linkIndex) => (
                    <a key={linkIndex} className="link" href={link.url}>
                      <link.icon className="icon" />
                    </a>
                  ))}
                </CardLinks>
              </CardContent>
            </Card>
          ))}
        </Cards>
      </ContentWithPaddingXl>
    </Container>
  );
};
export default TeamCardGrid;
